import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className"];
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
const Code = props => {
  const {
      className
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx("code", Object.assign({}, rest, {
    className: classNames(className, 'private-code')
  }));
};
export default Code;
Code.displayName = 'Code';